import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import CookieService from "../../context/cookies";
import { base } from "../../constants/apis";
import { ApiResponse } from "../../types/ApiResponse";
import { PartnerCompanyDetails } from "../../types/PartnerCompanyDetails";

export const partnerCompanyApi = createApi({
  reducerPath: "partnerCompanyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/partner_company_details`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["partnerCompanyApi"],
  endpoints: (builder) => ({
    getAllPartnerCompany: builder.query<PartnerCompanyDetails[], void>({
      query: () => "/get.php",
      transformResponse: (res: ApiResponse<PartnerCompanyDetails[]>) =>
        res.status === "success" ? res.data.reverse() : [],
      providesTags: ["partnerCompanyApi"],
    }),

    addPartnerCompany: builder.mutation({
      query: (body) => ({
        url: "/add.php",
        method: "POST",
        body,
      }),
      invalidatesTags: ["partnerCompanyApi"],
    }),

    updatePartnerCompany: builder.mutation({
      query: (body) => ({
        url: "/update.php",
        method: "POST",
        body,
      }),

      invalidatesTags: ["partnerCompanyApi"],
    }),
  }),
});

export const {
  useGetAllPartnerCompanyQuery,
  useAddPartnerCompanyMutation,
  useUpdatePartnerCompanyMutation,
} = partnerCompanyApi;
